import { render, staticRenderFns } from "./ModalScharffPointRestrictions.vue?vue&type=template&id=58cb3501&"
import script from "./ModalScharffPointRestrictions.vue?vue&type=script&lang=js&"
export * from "./ModalScharffPointRestrictions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports